import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/lib/api';
import { useAuthStore } from '@/stores/auth';

export interface DashboardKpis {
  avisosHoy: number;
  avisosAccion: number;
  tiempoRespuesta: string;
  ambulanciasLibres: string;
  ambulanciasDetalle: string;
  sinRecurso: number;
  sinRecursoDetalle: string;
}

export interface DashboardData {
  kpis: DashboardKpis;
}

/**
 * GET /api/dashboard — KPIs for the "Cuadro de mando".
 * The dashboard renders an empty/skeleton state until this resolves, so the
 * layout never jumps when data arrives.
 */
export function useDashboard() {
  const authenticated = useAuthStore((s) => s.authenticated);
  return useQuery({
    queryKey: ['dashboard'],
    queryFn: () => apiClient.get<DashboardData>('/dashboard'),
    enabled: authenticated,
  });
}
